import './forgotpassword.css';
import React, { useState, useEffect } from 'react';
import Spinner from '../Layout/Spinner';
import { useSelector } from 'react-redux';
import { FormControl,Button, FormHelperText } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { useLocation } from 'react-router-dom';
import commonService from '../../features/common/commonService';
import { toast } from 'react-toastify';


const EMAIL_NAME_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ForgotPassword() {

    const { role, isLoading, isError, isSuccess, message } = useSelector(
        (state) => state.auth
    )

    const [showPassword, setShowPassword] = React.useState(false);

    const [token, setToken] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [useError, setUseError] = useState(false);
    const [usePatternError, setUsePatternError] = useState(false);
    const PASSWORD_NAME_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/;

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const location = useLocation();

    useEffect(() => {
      // Access the query parameters here
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('token');
      console.log(token);
      setToken(token);
    }, [location]);


    const handleSubmit = (event) => {
        event.preventDefault();
        if(password == confirmPassword && !usePatternError){
            setUseError(false);
            commonService.checkUserbyToken(token, password)
            .then((response) => {
                console.log(response);
                toast.success(response.data.msg);
            })
            .catch((error)=>{
                console.log(error);
                toast.error(error.data.msg)
            });
        }else{
            setUseError(true);
        }
    }

    return (
        <>
            {isLoading && <Spinner />}
            <div className='mainContainer'>
                    <div className='forget_pageText'>Reset Password</div>
                    <div className='passwordInput'>
                        <FormControl sx={{ m: 1, width: "40ch" }} variant="outlined" error ={usePatternError}>
                            <InputLabel> Enter new password</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type="password"
                                label="Enter new password"
                                value={password}
                                onChange ={ ((event)=>{
                                       setPassword(event.target.value)
                                })}
                                onBlur = {((event)=>{
                                    if (!PASSWORD_NAME_REGEX.test(event.target.value) ) {
                                        console.log("Passwords are invalid.");
                                        setUsePatternError(true);
                                    }else{
                                        setUsePatternError(false);
                                    }
                                })}
                            />
                        {usePatternError && <FormHelperText> Password must contain at least one number, one lowercase and one uppercase letter and between 6 to 15 characters</FormHelperText>}
                        </FormControl>
                    </div>
                    <div className='confirmpasswordInput'>
                        <FormControl sx={{ m: 1, width: "40ch" }} variant="outlined" error ={useError}>
                            <InputLabel htmlFor="outlined-adornment-password"> Confirm new password </InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? "text" : "password"}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Confirm new password"
                                value = {confirmPassword}
                                onChange ={ ((event)=>{
                                    setConfirmPassword(event.target.value)
                                })}
                                onBlur = {((event)=>{
                                    if (!PASSWORD_NAME_REGEX.test(event.target.value) ) {
                                        console.log("Passwords are invalid.");
                                        setUsePatternError(true);
                                    }else{
                                        setUsePatternError(false);
                                    }
                                })}
                            />
                        {useError && <FormHelperText>Password & Confirm Password should match.</FormHelperText>}

                        </FormControl>

                    </div>
                    <div style={{ marginTop: '55px' }}>
                        <Button type="submit" className='signup' 
                        onClick = {handleSubmit}
                        sx={{ 
                            textAlign: 'center', 
                            height: 36, 
                            backgroundColor: '#3f51b5',
                            width: '15%', 
                            // borderRadius: 25, 
                            color: '#fff', 
                            ':hover': {
                                bgcolor: '#3f51b5',
                                color: '#fff',
                            }
                        }}>SUBMIT</Button>
                    </div>
            </div>
        </>
    )
}

export default ForgotPassword